import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import users from './modules/users'
import houses from './modules/houses'
import banners from './modules/banners'
import configs from './modules/configs'

import stats from './modules/stats'
import app from './modules/app'

Vue.use(Vuex)

const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.auth.token,
  adminInfo: state => state.auth.adminInfo,
  isAuthenticated: state => state.auth.isLoggedIn
}

export default new Vuex.Store({
  modules: {
    auth,
    users,
    houses,
    banners,
    configs,

    stats,
    app
  },
  getters,
  strict: process.env.NODE_ENV !== 'production'
})